import styled from 'styled-components';

export const Container = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 30px;
	grid-gap: 30px;
`;
